/**
 * Workaround to remove un-wanted dependency introduced by motif.
 *
 * motif has a dependency on the slate library, it is not used in Patient Portal.
 */
export default {};
